"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

function Oval(props) {
  var _a, _b;

  return react_1.default.createElement("svg", __assign({
    stroke: "#fff",
    viewBox: "0 0 38 38"
  }, __assign(__assign({}, props), {
    width: (_a = props.width) !== null && _a !== void 0 ? _a : 38,
    height: (_b = props.height) !== null && _b !== void 0 ? _b : 38,
    className: "icon-loading" + (props.className ? " " + props.className : '')
  })), react_1.default.createElement("g", {
    transform: "translate(1 1)",
    strokeWidth: 2,
    fill: "none",
    fillRule: "evenodd"
  }, react_1.default.createElement("circle", {
    strokeOpacity: 0.5,
    cx: 18,
    cy: 18,
    r: 18
  }), react_1.default.createElement("path", {
    d: "M36 18c0-9.94-8.06-18-18-18"
  }, react_1.default.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    from: "0 18 18",
    to: "360 18 18",
    dur: "1s",
    repeatCount: "indefinite"
  }))));
}

exports.default = Oval;